import { useEventListener } from '@vueuse/core';
import { BreakpointsEnum } from '@/js/enums/breakpoints';

const addClassOnScroll = (elements: NodeListOf<HTMLElement>, offset: number, className: string) => {
    const checkAndAnimateElements = () => {
        elements.forEach((element) => {
            const elementOffset = element.getBoundingClientRect().top - offset;

            if (elementOffset < window.innerHeight) {
                element.classList.add(className);
            }
        });
    };

    checkAndAnimateElements();
    useEventListener(
        window,
        'scroll',
        checkAndAnimateElements,
        { passive: true },
    );
};

const animateHowItWorksSection = () => {
    const howDoesItWorkSection: HTMLDivElement | null = document.querySelector('.how-does-it-work-steps');
    const stepElements: NodeListOf<HTMLElement> = document.querySelectorAll('.step');
    const arrowElements: NodeListOf<HTMLElement> = document.querySelectorAll('.arrow');
    const ANIMATE_CLASS = 'animate';

    if (howDoesItWorkSection) {
        const OFFSET = -100;
        addClassOnScroll(stepElements, OFFSET, ANIMATE_CLASS);
        addClassOnScroll(arrowElements, OFFSET, ANIMATE_CLASS);
    }
};

const animateVideoSection = () => {
    const videoComponents: NodeListOf<HTMLElement> = document.querySelectorAll('.v-component');

    if (videoComponents.length > 0) {
        const OFFSET = window.innerWidth <= BreakpointsEnum.TABLET_WIDTH_IN_PX ? 450 : 200;
        const ANIMATE_UP_CLASS = 'animate-up';
        addClassOnScroll(videoComponents, OFFSET, ANIMATE_UP_CLASS);
    }
};

useEventListener(document, 'DOMContentLoaded', () => {
    animateHowItWorksSection();
    animateVideoSection();
});
